export default {
  methods: {
    toLocale(value) {
      if (value === null) {
        return null;
      }

      const number = parseFloat(value);
      return number.toLocaleString();
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/mixins/hasPrices.js